const reducer = (state = {}, action) => {
  switch (action.type) {
    case "DRAWER_POSITION":
      return { ...action.payload, ...state, drawerOpen: action.payload.drawerOpen };
    case "LOGIN":
      return {
        ...action.payload,
        ...state,
        token: action.payload.login.token,
        authenticated: action.payload.login.authenticated,
        user: action.payload.login
      };
    case "THEME":
      return { ...action.payload, ...state, theme: action.payload.theme };
    case "EDIT_EVENTS":
      return { ...state, toEditEvent: action.payload.editEvents, oldStateFilter: action.payload.oldState };
    case "EDIT_EVENTS_OLD_STATE":
      return { ...state, toSetOldState: action.payload.setOldState };
    default:
      return state;
  }
};

export default reducer
